import { render, staticRenderFns } from "./casino-home-banner.vue?vue&type=template&id=c29c52fa"
import script from "./casino-home-banner.vue?vue&type=script&lang=js"
export * from "./casino-home-banner.vue?vue&type=script&lang=js"
import style0 from "./casino-home-banner.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/casino-home-banner.vue
// module id = aq6R
// module chunks = 0